import React from "react";
import NotificationsLayout from "../../../sections/BusinessDashboard/Inbox/Notifications/NotificationsLayout";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import {
  AdminPageTitle,
  AdminSupportingText,
} from "../../../sections/AdminDashboard/shared/adminUx";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const Notifications = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Alerts and notifications
      </AdminPageTitle>

      <div className="mx-auto min-h-screen">
        <NotificationsLayout />
        <AdminSupportingText className="mt-20 text-center text-mediumgray block">
          You&apos;ve reached the end of the list.
        </AdminSupportingText>
      </div>
    </DashboardMainContainer>
  );
};

export default Notifications;
